'use strict';

const ContactUs = require('base/contactUs/contactUs');
var scrollAnimate = require('../components/scrollAnimate');

/**
 * Checks for errors and then scrolls to first.
 */
 function checkErrors() {
    window.setTimeout(function () {
        var error = $('.is-invalid');
        if (error.length) {
            scrollAnimate(error);
        }
    }, 0);
}

ContactUs.clickSubmit = function () {

    $('.subscribe-contact-us').on('click', function (e) {
        checkErrors();
    });
};

module.exports = ContactUs;